var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActPacchetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 183,
    viewBox: "0 0 187 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3495 182.167L80.3495 14.1667C80.3495 6.34263 86.7146 -1.026e-06 94.5663 0L95.9879 1.8577e-07C103.84 1.21177e-06 110.205 6.34264 110.205 14.1667L110.205 182.167H80.3495Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7717 32.5832C22.7717 28.6712 25.9542 25.4999 29.8801 25.4999H149.227C152.055 25.4999 154.819 26.3404 157.165 27.9141L185.116 46.6611C187.669 48.373 187.618 52.1326 185.02 53.7753L157.053 71.4612C154.775 72.9017 152.133 73.6665 149.435 73.6665H29.8801C25.9542 73.6665 22.7717 70.4952 22.7717 66.5832V32.5832Z",
    fill: "#EF4443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.228 105.167C164.228 101.255 161.046 98.0832 157.12 98.0832H37.7731C34.9449 98.0832 32.181 98.9238 29.8348 100.497L1.88354 119.244C-0.668769 120.956 -0.617937 124.716 1.97973 126.359L29.9469 144.045C32.2247 145.485 34.8668 146.25 37.5646 146.25H157.12C161.046 146.25 164.228 143.079 164.228 139.167V105.167Z",
    fill: "#EF4443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActPacchetti);
export default __webpack_public_path__ + "static/media/act-pacchetti.c859e82c64c5737eead9fb362f48f675.svg";
export { ForwardRef as ReactComponent };